'use strict';

(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.dlaLoggedInHide = {
    attach: function attach(context, settings) {
      // $(document, context).once('logged-in').ready(function() {
      $(once('logged-in', 'html', context)).ready(function() {
        $('.view-display-id-page_saved .flag.action-unflag a').on('click', function (i) {
          $(i.currentTarget).parents('li').fadeOut();
        });
        $('.view-display-id-page_completed .flag.action-unflag a').on('click', function (i) {
          $(i.currentTarget).parents('li').fadeOut();
        });
      })
    }
  };

})(jQuery, Drupal, once);
